// extracted by mini-css-extract-plugin
export var avatarContainer = "_gj-0";
export var avatarTypingWave = "_gj-i";
export var gray = "_gj-f";
export var green = "_gj-c";
export var icon = "_gj-9";
export var image = "_gj-1";
export var lg = "_gj-6";
export var md = "_gj-5";
export var presenceDot = "_gj-b";
export var red = "_gj-d";
export var sm = "_gj-4";
export var status = "_gj-a";
export var typingDot = "_gj-h";
export var typingPill = "_gj-g";
export var xl = "_gj-7";
export var xs = "_gj-3";
export var xxl = "_gj-8";
export var xxs = "_gj-2";
export var yellow = "_gj-e";